// extracted by mini-css-extract-plugin
export var footer = "_qh-0";
export var inherit = "_qh-1";
export var input = "_qh-2";
export var modalContent = "_qh-3";
export var quillEditor = "_qh-4";
export var subtitle = "_qh-5";